import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

class TabsTwo extends Component {
  state = {
    active: false,
  };
  render() {
    let tab1 = "Skills";

    let tab2 = "Education & Certification";
    const { tabStyle } = this.props;
    return (
      <div>
        {/* Start Tabs Area */}
        <div className="tabs-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Tabs>
                  <TabList className={`${tabStyle}`}>
                    <Tab
                      style={{
                        color: (!this.state.active && "#008bff") || "#fff",
                      }}
                      onClick={() => this.setState({ active: false })}
                    >
                      {tab1}
                    </Tab>

                    <Tab
                      style={{
                        color: (this.state.active && "#008bff") || "#fff",
                      }}
                      onClick={() => this.setState({ active: true })}
                    >
                      {tab2}
                    </Tab>
                  </TabList>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="#service">Web Development</a>I build websites
                          and web apps using Javascript and it's frameworks. I
                          use technologies like HTML, CSS, Javascript, Node.js,
                          React JS, Firebase, etc and tools like: VSCode,Git,
                          Docker, AWS, Github.
                        </li>
                        <li>
                          <a href="#service">App Development</a>I build mobile
                          and Desktop apps using Javascript frameworks and
                          libraries like React Native, Cordova, Ionic Framework
                          and Electron.
                        </li>

                        <li>
                          <a href="#service">
                            Internet of Things <span> - Embedded Systems</span>
                          </a>
                          I design, simulate, prototype and build IoT systems
                          using tools like Proteus, Altium Designer, Breadboard,
                          Atmel Studio, Arduino, etc.
                        </li>
                      </ul>
                    </div>
                  </TabPanel>

                  {/* <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="/service">
                            Awwwards.com <span>- Winner</span>
                          </a>{" "}
                          2019 - 2020
                        </li>
                        <li>
                          <a href="/service">
                            CSS Design Awards <span>- Winner</span>
                          </a>{" "}
                          2017 - 2018
                        </li>
                        <li>
                          <a href="/service">
                            Design nominees <span>- site of the day</span>
                          </a>{" "}
                          2013- 2014
                        </li>
                      </ul>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="/service">
                            Sr. Front-end Engineer<span> - Google</span>
                          </a>{" "}
                          2018 - Current
                        </li>
                        <li>
                          <a href="/service">
                            Front-end Engineer<span> - Microsoft</span>
                          </a>{" "}
                          2017 - 2018
                        </li>
                        <li>
                          <a href="/service">
                            Software Engineer<span> - Alibaba </span>
                          </a>{" "}
                          2013- 2014
                        </li>
                      </ul>
                    </div>
                  </TabPanel> */}

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="/service">
                            Computer Engineering
                            <span>
                              {" "}
                              - Federal University of Technology Minna, Nigeria,
                              2023
                            </span>
                          </a>{" "}
                          Bachelor's degree in Computer Engineering, FUTMinna
                          Nigeria.
                        </li>
                        <li>
                          <a href="https://freecodecamp.org/certification/fccdd825543-641a-4c96-a7c0-c76b1005cd4d/javascript-algorithms-and-data-structures">
                            Javascript Algorithms and Data Structures
                            <span> - freeCodeCamp, 2021</span>
                          </a>{" "}
                          Online course on Algorithms and Data Structures in
                          Javascript. The course covered basic to advance
                          concept on algorithms and data structures. Solved many
                          problems and challenges and earned a{" "}
                          <a href="https://freecodecamp.org/certification/fccdd825543-641a-4c96-a7c0-c76b1005cd4d/javascript-algorithms-and-data-structures">
                            Certificate
                          </a>
                          .
                        </li>
                        <li>
                          <a href="https://www.sololearn.com/Certificate/1097-16731637/pdf/">
                            React + Redux
                            <span> - Sololearn, 2020</span>
                          </a>{" "}
                          An online tutorial on React.js and redux, during the
                          course I built a phonebook app in React and Redux.
                        </li>
                      </ul>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {/* End Tabs Area */}
      </div>
    );
  }
}

export default TabsTwo;
